import { render, staticRenderFns } from "./Separate.vue?vue&type=template&id=38306b4a&"
import script from "./Separate.vue?vue&type=script&lang=js&"
export * from "./Separate.vue?vue&type=script&lang=js&"
import style0 from "./Separate.vue?vue&type=style&index=0&id=38306b4a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports